import gql from 'graphql-tag';

import client from '../graphqlAPI';

const PRODUCTS_REMOVE = gql`
  mutation Post($productId: String!, $restore: Boolean) {
    productRemove(productId: $productId, restore: $restore) {
      result
      error
    }
  }
`;

const productRemove = async ({ productId, restore }) => {
  try {
    const result = await client
      .mutate({
        mutation: PRODUCTS_REMOVE,
        variables: { productId, restore },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { productRemove: productRemoveData },
    } = result;

    if (productRemoveData) {
      return productRemoveData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: productRemove`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: productRemove Error: ${error}`);
    return null;
  }
};

export default productRemove;
